import { render, staticRenderFns } from "./Ta.vue?vue&type=template&id=175d2207&scoped=true"
import script from "./Ta.vue?vue&type=script&lang=js"
export * from "./Ta.vue?vue&type=script&lang=js"
import style0 from "./Ta.vue?vue&type=style&index=0&id=175d2207&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175d2207",
  null
  
)

export default component.exports